/** Pure collage-geometry helpers (kept out of the component file so Fast Refresh
 * stays happy — see react-refresh/only-export-components). */

export type Edge = 'top' | 'right' | 'bottom' | 'left';

/** seeded rng so collage placement is deterministic (stable across renders) */
export function wwRng(seed: number) {
  let a = seed >>> 0;
  return () => {
    a |= 0;
    a = (a + 0x6d2b79f5) | 0;
    let t = Math.imul(a ^ (a >>> 15), 1 | a);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

/** torn-paper clip-path polygon. edges: which sides get a torn jitter. */
export function wwTornPath(edges: Edge[] = ['bottom'], seed = 7, amp = 2.4, step = 7) {
  const r = wwRng(seed);
  const has = (e: Edge) => edges.includes(e);
  const pts: [number, number][] = [];
  const jit = (on: boolean) => (on ? (r() * 2 - 1) * amp : 0);
  for (let i = 0; i <= step; i++) {
    const x = (i / step) * 100;
    pts.push([x, Math.max(0, jit(has('top')))]);
  }
  for (let i = 1; i <= step; i++) {
    const y = (i / step) * 100;
    pts.push([100 - Math.max(0, jit(has('right'))), y]);
  }
  for (let i = 1; i <= step; i++) {
    const x = 100 - (i / step) * 100;
    pts.push([x, 100 - Math.max(0, jit(has('bottom')))]);
  }
  for (let i = 1; i < step; i++) {
    const y = 100 - (i / step) * 100;
    pts.push([Math.max(0, jit(has('left'))), y]);
  }
  return 'polygon(' + pts.map((p) => `${p[0].toFixed(1)}% ${p[1].toFixed(1)}%`).join(',') + ')';
}
